import { stack } from "../utils/data";

const Stack = () => (
  <section
    id="stack"
    className="scroll-mt-20 border-b border-paper-300 py-24 lg:py-32"
  >
    <div className="mx-auto max-w-shell px-6 lg:px-10">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-10">
        <div className="lg:col-span-4">
          <p className="eyebrow eyebrow-dot">{stack.eyebrow}</p>
          <h2 className="display mt-5 text-display-md text-ink-950">
            {stack.heading}
          </h2>
        </div>

        <div className="lg:col-span-8">
          {stack.groups.map((group) => (
            <div
              key={group.label}
              className="grid gap-4 border-t border-paper-300 py-7 sm:grid-cols-4 sm:gap-6 last:border-b"
            >
              <p className="font-mono text-micro uppercase text-ink-500 sm:pt-1">
                {group.label}
              </p>
              <div className="flex flex-wrap gap-2 sm:col-span-3">
                {group.items.map((item) => (
                  <span
                    key={item}
                    className="border border-paper-300 bg-white px-3.5 py-2 font-display text-sm font-medium tracking-tight text-ink-700 transition-colors duration-200 hover:border-clay hover:text-clay-dim"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Stack;
